import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  content: {
    backgroundColor: '#fff',
    position: 'relative',
    maxWidth: '460px',
    padding: '15px',
    borderRadius: '8px',
    fontSize: '16px',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    padding: '44px 24px 24px 24px',
    gap: '19px',
  },
  title: {
    fontWeight: 700,
    fontSize: '20px',
    textAlign: 'center',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0 15px',
    gap: '15px',
  },
  text: {
    textAlign: 'center',
  },
  link: {
    color: 'rgba(41, 121, 255, 0.87)',
  },
  button: {
    textTransform: 'uppercase',
  },
  loader: {
    color: '#fff',
  }
}))
